import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { BasketService } from '../_services/basket.service';
import { CustomerService } from '../_services/customer.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { HttpEventType } from '@angular/common/http';

@Component({
    selector: 'app-import',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.css'],
    standalone: false
})
export class ImportComponent implements OnInit {
  brands: string[];
  importForm: FormGroup;
  enableUpload: boolean;
  fileContent: any;
  file: File;
  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(private customerService: CustomerService, private fb: FormBuilder, private basketService: BasketService, private toastr: ToastrService,private router: Router) { }

  ngOnInit(): void {  
    this.customerService.currentUser$.subscribe(prijslijstlijnen => { 
      this.brands = [...prijslijstlijnen.brands];  
      //var index: number = this.brands.indexOf("ANY", 0);
      //if (index > -1){
      //  this.brands.splice(index, 1);
      //}        
    });

    this.initializeForm();
  }

  initializeForm(){
    this.importForm = this.fb.group({
      brand: [this.brands[0]],
      myfile: ['']

   })
  }

  public readFile(event) {
    this.enableUpload = false;
    let af = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
    if (event.target.files.length > 0) {
      this.file = <File>event.target.files[0];
      if (!_.includes(af, this.file.type)) {
        alert('Only EXCEL Docs Allowed!');
      } else {
        this.importForm.get('myfile').setValue(this.file);
        this.enableUpload = true;
      }
    }
  }

  public upload() {
    if (!this.importForm.get('myfile').value) {
      alert('Please fill valid details!');
      return false;
    }

    // mandate for accepting binary content
    const formData = new FormData();
    formData.append('file', this.file, this.file.name);
    try {
      if (this.importForm.get('brand').value == 'ANY')
      {
        this.basketService.UploadExcelfileAllBrands(formData).subscribe(event =>{ 
          if (event.type === HttpEventType.UploadProgress)
          {
            //this.progress = Math.round(100 * event.loaded / event.total);
            console.log(Math.round(100 * event.loaded / event.total));
          }  
          else if (event.type === HttpEventType.Sent) {
            console.log("upload success for all brands")
            this.toastr.success("File has been uploaded (All brands)");
          }       
          else if (event.type === HttpEventType.Response) {
            console.log("upload success for all brands")
            //this.message = 'Upload success.';
            //this.onUploadFinished.emit(event.body);
          }
        }, error => {
          this.toastr.error(error);
          console.log(error);
        }, () => {
          this.toastr.success("File has been imported");
          this.router.navigateByUrl('/order');
        });
      }
      else
      {
        this.basketService.UploadExcelfile(formData, this.importForm.get('brand').value).subscribe(event =>{ 
          if (event.type === HttpEventType.UploadProgress)
          {
            //this.progress = Math.round(100 * event.loaded / event.total);
            console.log(Math.round(100 * event.loaded / event.total));
          }  
          else if (event.type === HttpEventType.Sent) {
            console.log("upload success")
            this.toastr.success("File has been uploaded");
          }       
          else if (event.type === HttpEventType.Response) {
            console.log("upload success")
            //this.message = 'Upload success.';
            //this.onUploadFinished.emit(event.body);
          }
        }, error => {
          this.toastr.error(error);
          console.log(error);
        }, () => {
          this.toastr.success("File has been imported");
          this.router.navigateByUrl('/order');
        });
      }

        

    } catch (e) {
        console.log('Error occured while posting uploaded file. See below message for details : \n');
        console.log(e);
    }
    
  }

}


